export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-indent-less-e7a79af1771c10005cf6114dbef9d7ab.svg";